if (!customElements.get('accordion-animate')) {
  class AccordionAnimate extends HTMLElement {
    constructor() {
      super();
      this.animations = new Map();
    }

    connectedCallback() {
      this.handleClick = this.handleClick.bind(this);
      this.querySelectorAll('summary').forEach((s) =>
        s.addEventListener('click', this.handleClick)
      );
    }

    disconnectedCallback() {
      this.querySelectorAll('summary').forEach((s) =>
        s.removeEventListener('click', this.handleClick)
      );
    }

    handleClick(event) {
      event.preventDefault();
      const details = event.currentTarget.closest('details');
      if (!details) return;

      const running = this.animations.get(details);
      if (running) running.cancel();

      details.open ? this.shrink(details) : this.expand(details);
    }

    getContentMetrics(content) {
      const cs = getComputedStyle(content);
      return {
        height: content.scrollHeight,
        paddingTop: cs.paddingTop,
        paddingBottom: cs.paddingBottom,
        marginBottom: cs.marginBottom,
      };
    }

    expand(details) {
      const content = details.querySelector('.accordion__content');
      if (!content) return;

      content.style.height = '0px';
      content.style.paddingTop = '0px';
      content.style.paddingBottom = '0px';
      content.style.marginBottom = '0px';
      content.style.overflow = 'hidden';

      details.open = true;

      this.clearStyles(details, content);
      const end = this.getContentMetrics(content);

      content.style.height = '0px';
      content.style.paddingTop = '0px';
      content.style.paddingBottom = '0px';
      content.style.marginBottom = '0px';
      content.style.overflow = 'hidden';

      const anim = content.animate(
        [
          { height: '0px', paddingTop: '0px', paddingBottom: '0px', marginBottom: '0px' },
          { height: end.height + 'px', paddingTop: end.paddingTop, paddingBottom: end.paddingBottom, marginBottom: end.marginBottom },
        ],
        { duration: 300, easing: 'ease' }
      );

      this.animations.set(details, anim);
      anim.onfinish = () => this.clearStyles(details, content);
      anim.oncancel = () => this.clearStyles(details, content);
    }

    shrink(details) {
      const content = details.querySelector('.accordion__content');
      if (!content) return;

      const start = this.getContentMetrics(content);
      content.style.overflow = 'hidden';
      details.classList.add('closing');

      const anim = content.animate(
        [
          { height: start.height + 'px', paddingTop: start.paddingTop, paddingBottom: start.paddingBottom, marginBottom: start.marginBottom },
          { height: '0px', paddingTop: '0px', paddingBottom: '0px', marginBottom: '0px' },
        ],
        { duration: 300, easing: 'ease' }
      );

      this.animations.set(details, anim);
      anim.onfinish = () => {
        details.open = false;
        details.classList.remove('closing');
        this.clearStyles(details, content);
      };
      anim.oncancel = () => {
        details.classList.remove('closing');
        this.clearStyles(details, content);
      };
    }

    clearStyles(details, content) {
      content.style.height = '';
      content.style.paddingTop = '';
      content.style.paddingBottom = '';
      content.style.marginBottom = '';
      content.style.overflow = '';
      this.animations.delete(details);
    }
  }

  customElements.define('accordion-animate', AccordionAnimate);
}
